// Uniform provider component
import React, {useRef} from "react";

import {useFrame, useThree} from "@react-three/fiber";
import {Vector2} from "three";

import {UniformsContext} from "./Uniforms";

export const UniformsProvider: React.FC<{children: React.ReactNode}> = ({
  children,
}) => {
  const {gl, camera} = useThree();

  // Use useRef to keep a stable reference to the uniforms object
  const uniforms = useRef({
    iResolution: {
      value: new Vector2(gl.domElement.width, gl.domElement.height),
    },
    iTime: {value: 0.0},
    iScale: {value: 1.0},
    iCameraPosition: {
      value: new Vector2(camera.position.x, camera.position.y),
    },
  });

  useFrame(({clock, camera, gl}) => {
    // Update uniform values in the ref object without replacing the object
    uniforms.current.iTime.value = clock.getElapsedTime();
    uniforms.current.iResolution.value.set(
      gl.domElement.width,
      gl.domElement.height,
    );
    uniforms.current.iScale.value = camera.zoom;
    uniforms.current.iCameraPosition.value.set(
      camera.position.x,
      camera.position.y,
    );
  });

  return (
    <UniformsContext.Provider value={uniforms.current}>
      {children}
    </UniformsContext.Provider>
  );
};
